import { taskStatusesSlice } from "./taskStatusesSlice";
import * as actions from "./taskStatusesActions";
import * as selectors from "./taskStatusesSelectors";

export { actions };
export { selectors };
export default taskStatusesSlice.reducer;